import { twMerge } from "tailwind-merge"
const Heading3: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, children, ...props }) => {
  return (
    <h3 className={twMerge("font-bricolage font-extrabold text-[2.5rem] leading-[100%]", className)} {...props}>
      {children}
    </h3>
  )
}

export default Heading3
